import { initContract } from "@ts-rest/core";
import { z } from "zod";
import {
  backofficeAuthenticationResponseSchema,
  backofficeCurrentOperatorResponseSchema,
  backofficeOperatorAccess,
} from "~infrastructure/api/backoffice/contract/authentication/responses/authentication-responses.ts";
import { backofficeUnauthorizedResponseSchema } from "~infrastructure/api/backoffice/contract/global/responses/global-backoffice-responses.ts";

const c = initContract();

export const authenticationBackofficeContract = c.router(
  {
    loginWithCaptcha: {
      method: "POST",
      path: "/external/login/token",
      body: z.object({
        username: z.string(),
        password: z.string(),
      }),
      headers: z.object({
        "x-captcha-client": z.string(),
        "x-captcha-token": z.string(),
      }),
      responses: {
        200: backofficeAuthenticationResponseSchema,
        400: z.object({
          error: z.literal("invalid_grant"),
          error_description: z.string(),
        }),
      },
    },
    loginWithoutCaptcha: {
      method: "POST",
      path: "/login/token",
      body: z.object({
        username: z.string(),
        password: z.string(),
      }),
      responses: {
        200: backofficeAuthenticationResponseSchema,
        400: z.object({
          error: z.literal("invalid_grant"),
          error_description: z.string(),
        }),
      },
    },
    getCurrentOperatorInfo: {
      method: "GET",
      path: "/api/operator/me",
      responses: {
        200: backofficeCurrentOperatorResponseSchema,
        401: backofficeUnauthorizedResponseSchema,
      },
    },
    getOperatorAccesses: {
      method: "GET",
      path: "/api/access",
      responses: {
        200: backofficeOperatorAccess.array(),
        401: backofficeUnauthorizedResponseSchema,
      },
    },
  },
  {
    strictStatusCodes: true,
  },
);
